var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"main-layout theme-grey-full",class:{ 'sidebar-opened': this.$store.state.sidebar.visible,
  'sidebar-mini': this.$store.state.sidebar.mini }},[_c('navbar'),_c('sidebar'),_c('section',{staticClass:"main-content-wrapper"},[_c('child')],1),_c('notifications')],1)}
var staticRenderFns = []

export { render, staticRenderFns }